import { Component, OnInit, ViewChild } from '@angular/core';
import {
  InformesSearch, InformeContabilidadConsultas, FiltroInformeContabilidadConsultas, InformeConsultas,
  InformeContabilidadConsultasContenido
} from '../../../core/model/informes';
import { FormGroup, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { InformesService } from '../../../core/services/informes/informes.service';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { HttpClient } from '@angular/common/http';
import { UtilitiesService } from '../../../core/services/Utility/utilities.service';
import { first } from 'rxjs/operators';
import { FileData, MassiveLoadResult } from '../../../core/model/massive-load-result';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-act-contenidos-masiva',
  templateUrl: './act-contenidos-masiva.component.html',
  styleUrls: ['./act-contenidos-masiva.component.css']
})
export class ActContenidosMasivaComponent implements OnInit {

  Boxtype = 'box-primary';
  @ViewChild('fileInput') fileInput;

  private onFileUploaded = new Subject<FileData>();
  loading = false;
  cargando = false;
  fileName = '';
  nombreFichero = '';
  resultadoValidacionFichero: MassiveLoadResult;
  autoLoad: any;
  onClose: any;
  toastService: any;
  resultadoPrueba: number;
  ficheroValidado: boolean;
  ficheroSeleccionado: boolean;
  checkMarcado = false;

  constructor(
    private http: HttpClient,
    private utilitiesService: UtilitiesService,
    private toastr: ToastrService,
    private informeService: InformesService,
  ) { }

  ngOnInit() {
  }
  
  cargarFile() {

    if (this.ficheroValidado == false) {
      this.toastr.info('El fichero actual no esta validado.'); 
    }
    else {

      this.cargando = true;
      const file: File = this.fileInput.nativeElement.files[0];
      const fileData: FileData = this.createFileData(file);
      this.onFileUploaded.next(fileData);

      this.informeService.getcargarFileActMasCon(file, this.checkMarcado)
        .subscribe((result: any) => {
          this.cargando = false;
          if (result == 1) {
            this.cargando = false;
            this.toastr.success('El fichero se ha cargado de forma correcta.');
            this.limpiarFileName();
            } else  {
            this.cargando = false;
            this.toastr.error('El fichero no se ha podido cargar.');
            this.ficheroValidado = false;
            }
        },
          error => {
            this.cargando = false;
            if (error.error.Message == 'No se ha encontrado ningun contenidos que actualizar valido.')
            {
              this.toastr.warning('No se ha encontrado ningun contenido que actualizar valido.'); 
            }
            else
            {
              this.toastr.error('Ha ocurrido un error al cargar el fichero masiva. Por favor, inténtelo de nuevo más tarde');  
              }
            
            this.limpiarFileName();
          });
    }
  }

  validarFile() {

    if (this.ficheroValidado == true) {
      this.toastr.info('El fichero actual ya esta validado.'); 
    }
    else {

      this.loading = true;
    const file: File = this.fileInput.nativeElement.files[0];
    const fileData: FileData = this.createFileData(file);
    this.onFileUploaded.next(fileData);

    this.informeService.getvalidateFileActMasCon(file)
        .subscribe((result: any) => {
          this.loading = false;
          if (result == 1) {
            this.loading = false;
            this.toastr.success('El fichero pasa la validación.');
            this.ficheroValidado = true;
            } else  {
              this.loading = false;
            this.toastr.error('El fichero no pasa la validación.');
            this.ficheroValidado = false;
            }
        },
          error => {
            this.loading = false;
            this.toastr.error('Ha ocurrido un error al validar el fichero de carga masiva. Por favor, inténtelo de nuevo más tarde');
            this.ficheroValidado = false;
          });
    }
  }

  changeFileName() {
    this.ficheroSeleccionado = true;
    this.fileName = this.fileInput.nativeElement.files[0].name;
    this.nombreFichero = this.fileName;
    this.ficheroValidado = false;
  }

  limpiarFileName() {
    this.ficheroSeleccionado = false;
    this.ficheroValidado = false;
    this.nombreFichero = '';
  }

  downloadPlantilla(path?: string) {
    let plantillaPath = '/assets/plantilla/PlantillaActualizarMasiva.xlsx';;
    this.http.get(plantillaPath, { responseType: 'blob' }).pipe(first())
      .subscribe(data => {
            this.utilitiesService.downloadGenericFile(plantillaPath.substring(plantillaPath.lastIndexOf('/') + 1), data);
          }, error => {
            this.toastr.error('No ha sido posible descargar la plantilla.');
          });
      }

  private createFileData(file: File, guid?: string): FileData {
    const fileData: FileData = new FileData();
    fileData.filename = file.name;
    fileData.extension = this.getExtension(file.name);
    fileData.size = this.calculateSizeFile(file.size);
    fileData.file = file;
    fileData.guid = guid;

    return fileData;
  }
  
  private getExtension(filename: string): string {
    const splitPoint = filename.split('.');
    return splitPoint[splitPoint.length - 1];
  }

  private calculateSizeFile(size: number): string {
    const sizeInKb = Math.ceil(size / 1000);
    if (sizeInKb < 1000) {
      return sizeInKb + ' Kb';
    }

    return Math.ceil(sizeInKb / 1000) + ' Mb';
  }
  
  }

